import { telemetry } from './../helpers';

import { LOCATION_CHANGE } from './../actions';

const initialState = { pageType: '' };

const axiomTelemetryPage = (state = initialState, action) => {
  if (action.type === LOCATION_CHANGE) {
    if (!action.payload) {
      return state;
    }
    switch (action.payload.pathname) {
      case '/telemetry-process':
        return {
          ...state,
          pageType: telemetry.PROCESS
        };
      case '/telemetry-examine':
        return {
          ...state,
          pageType: telemetry.EXAMINE
        };
      case '/telemetry-axiom-scans-today':
        return {
          ...state,
          pageType: telemetry.AXIOM_SCANS_TODAY
        };
      case '/artifact-stats':
        return {
          ...state,
          pageType: telemetry.ARTIFACT_STATS
        };
      case '/jira-metrics':
        return {
          ...state,
          pageType: telemetry.JIRA_METRICS
        };
      default:
        return state;
    }
  }
  return state;
};
export default axiomTelemetryPage;

const getAxiomTelemetryPage = state => state.axiomTelemetryPage;

export const getTelemetryPageType = state => getAxiomTelemetryPage(state).pageType;



// WEBPACK FOOTER //
// src/reducers/axiomTelemetryPage.js